export default __webpack_public_path__ + "static/media/logo.f7fa9422.svg";